import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * AdSense slot component. Renders placeholder when no code is configured,
 * or injects the actual AdSense script when configured by admin.
 */
export default function AdSenseSlot({ slotId, width = 300, height = 250, className = '' }) {
  const { t } = useLanguage();
  const containerRef = useRef(null);
  const adCode = window.__CT_ADSENSE_CODE__ || localStorage.getItem('ct_adsense_code');

  // Check if user has ad-free subscription
  const localUser = JSON.parse(localStorage.getItem('ct_user') || 'null');
  const subscription = localUser?.subscription || 'free';
  const isAdFree = ['basic', 'premium', 'lifetime'].includes(subscription);

  useEffect(() => {
    if (adCode && containerRef.current && !isAdFree) {
      try {
        const range = document.createRange();
        const fragment = range.createContextualFragment(adCode);
        containerRef.current.appendChild(fragment);
      } catch (e) {
        // Invalid code - show placeholder
      }
    }
  }, [adCode, isAdFree]);

  // Don't show ads to paid subscribers
  if (isAdFree) return null;

  if (adCode) {
    return (
      <div ref={containerRef} className={`overflow-hidden ${className}`} style={{ width, minHeight: height }} data-testid="adsense-real-slot" />
    );
  }

  return (
    <div
      className={`adsense-slot ${className}`}
      style={{ width: '100%', height }}
      data-testid="adsense-placeholder"
    >
      <div className="text-center">
        <p className="text-gray-400 text-xs font-accent uppercase tracking-wide mb-1">Advertisement</p>
        <p className="text-gray-300 text-xs">{width} × {height}</p>
        <p className="text-gray-300 text-xs mt-1 opacity-70">Configure in Admin → Settings → AdSense</p>
      </div>
    </div>
  );
}
